import React, { PropsWithChildren, ReactNode, Ref, forwardRef } from 'react';
import { universalRenderer } from 'utils/universalRenderer';
import { classNames } from 'primereact/utils';
import { Box } from '../Box';
import './Page.scss';

export type PageProps = PropsWithChildren<{
	className?: string;
	beforeLeft?: ReactNode | (() => ReactNode);
	beforeRight?: ReactNode | (() => ReactNode);
	afterLeft?: ReactNode | (() => ReactNode);
	afterRight?: ReactNode | (() => ReactNode);
	header?: ReactNode | (() => ReactNode);
	scrollable?: boolean;
}>;

export const Page = forwardRef(
	(
		{
			beforeLeft,
			beforeRight,
			afterLeft,
			afterRight,
			header,
			children,
			className,
			scrollable = false,
			...restProps
		}: PageProps,
		ref: Ref<HTMLDivElement>
	) => {
		return (
			<div
				className={classNames('page-container', {
					'flex-1 flex flex-column h-full overflow-hidden': scrollable,
				})}
			>
				{(beforeLeft || beforeRight) && (
					<div className="flex flex-row justify-between mb-2">
						{beforeLeft && (
							<div className="flex-1 flex justify-content-start">{universalRenderer(beforeLeft)}</div>
						)}
						{beforeRight && (
							<div className="flex-1 flex justify-content-end">{universalRenderer(beforeRight)}</div>
						)}
					</div>
				)}
				<Box
					id="pageScrollWrapperRef"
					ref={ref}
					className={classNames('page', { 'flex-1 h-full overflow-y-scroll': scrollable })}
					{...restProps}
				>
					{header && <div>{universalRenderer(header)}</div>}
					<div className={classNames(className, { 'flex-1 h-full': scrollable })}>{children}</div>
				</Box>
				{(afterLeft || afterRight) && (
					<div className="flex flex-row justify-between mt-2">
						{afterLeft && (
							<div className="flex-1 flex justify-content-start">{universalRenderer(afterLeft)}</div>
						)}
						{afterRight && (
							<div className="flex-1 flex justify-content-end">{universalRenderer(afterRight)}</div>
						)}
					</div>
				)}
			</div>
		);
	}
);
